<template>
  <b-modal class="dialog" :active.sync="active" has-modal-card>
    <div class="modal-card" style="width: auto">
      <section class="modal-card-body is-titleless">
        <textarea class="input note mt-10 mb-10"
                  ref="noteInput"
                  v-model="note"
                  :placeholder="$t('interface.inputNote')">
        </textarea>
        <b-field class="file">
          <b-upload v-model="file">
            <a class="button is-warning">
              <span>{{ $t('docflow.fields.file') }}</span>
            </a>
          </b-upload>
          <span class="file-name">
                        {{ file ? file.name : $t('interface.noFileSelected') }}
                    </span>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-primary" @click="submit">OK</button>
        <button class="button is-danger" type="button" @click="$emit('update:active', false)">
          {{ $t('interface.cancel') }}
        </button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
  import {prepareDate} from '../utils'

  export default {
    name: "DocumentChangeRequest",
    props: ['active'],
    data() {
      return {
        note: '',
        file: null
      }
    },
    methods: {
      submit() {
        if (this.note === "" || !this.file) {
          this.$toast.open(this.$t('interface.allRequired'))
          return false
        }
        this.$store.dispatch('Docflow/createChangeRequest', {
          note: this.note,
          file: this.file
        }).then(() => {
          this.$emit('change', true)
        }).finally(() => {
          this.$emit('update:active', false)
        })
      }
    }
  }
</script>

<style scoped>
  .note {
    resize: vertical;
    min-height: 120px;
    padding-top: 10px;
  }

  .modal-card-body {
    width: 400px;
  }

  .dialog .modal-card .modal-card-body .field {
    margin-top: 0 !important;
  }
</style>
